import { create } from 'zustand';
import type { SelectedRef } from '@/features/multi-select/selection';

/**
 * La MULTI-SÉLECTION courante — les mails et dossiers déjà rangés que
 * l'utilisateur a cochés au clavier/souris dans l'arbre ou la page détail.
 *
 * À NE PAS CONFONDRE AVEC `selectionStore`, qui porte la sélection faite dans
 * OUTLOOK (les mails de la boîte que « Ranger ici » va classer). Les deux
 * coexistent volontairement : l'une désigne la source d'un rangement, l'autre des
 * éléments déjà rangés sur lesquels agir. Les mélanger rendrait « Ranger 3 mails
 * ici » indiscernable de « déplacer 3 mails ».
 *
 * LA SÉLECTION EST PORTÉE PAR UNE PORTÉE (`scope`) et ne lui survit pas : une
 * sélection faite dans un dossier n'a aucun sens dans un autre, et la laisser
 * vivre ferait agir un menu « Supprimer 4 éléments » sur des lignes que
 * l'utilisateur ne voit plus. Toute écriture dans une portée différente remplace
 * l'ancienne.
 */
interface ItemSelectionState {
  scope: string | null;
  items: SelectedRef[];
  /** Dernière ligne cliquée sans MAJ : l'origine d'une future plage. */
  anchorId: string | null;
  setSelection: (scope: string, items: SelectedRef[], anchorId: string | null) => void;
  clear: () => void;
}

export const useItemSelectionStore = create<ItemSelectionState>((set) => ({
  scope: null,
  items: [],
  anchorId: null,
  setSelection: (scope, items, anchorId) => set({ scope, items, anchorId }),
  clear: () => set({ scope: null, items: [], anchorId: null }),
}));

/** Les éléments sélectionnés DANS cette portée, ou rien. Jamais ceux d'une autre. */
export function selectionFor(
  state: Pick<ItemSelectionState, 'scope' | 'items'>,
  scope: string,
): SelectedRef[] {
  return state.scope === scope ? state.items : [];
}
